import {
  BulkProcessProjectTimeRecordDocument,
  BulkProcessProjectTimeRecordMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export interface IBulkProcessItemTimeRecord {
  timeRecordId?: number
  attendanceShiftId: number
  projectWorkerId?: number
  subprojectId?: number
}

export interface IBulkProcessTimeRecord {
  items: IBulkProcessItemTimeRecord[]
}

export const useBulkProcessProjectTimeRecord = () => {
  const [bulkProcessTimeRecord, { loading }] = useMutation(BulkProcessProjectTimeRecordDocument, {
    extractorFn: (data: BulkProcessProjectTimeRecordMutation) =>
      data.projectManagementMutations.bulkProcessProjectmanagementTimeRecord,
  })

  return {
    loading,
    bulkProcessProjectTimeRecord({ items }: IBulkProcessTimeRecord) {
      return bulkProcessTimeRecord({ variables: { items } })
    },
  }
}
